import { render, staticRenderFns } from "./points_gift.vue?vue&type=template&id=35c12454&scoped=true"
import script from "./points_gift.vue?vue&type=script&lang=js"
export * from "./points_gift.vue?vue&type=script&lang=js"
import style0 from "./points_gift.vue?vue&type=style&index=0&id=35c12454&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c12454",
  null
  
)

export default component.exports